import {
  FETCH_FAQS_REQUEST,
  FETCH_FAQS_SUCCESS,
  FETCH_FAQS_FAILURE
} from "Constants/redux";

const INITIAL_STATE = {
  faqs: [],
  loading: false
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case FETCH_FAQS_REQUEST:
      return { ...state, loading: true };

    case FETCH_FAQS_FAILURE:
      return { ...state, loading: false };
    case FETCH_FAQS_SUCCESS:
      return {
        ...state,
        faqs: action.response.data.faqs,
        loading: false
      };
    default:
      return state;
  }
};
